var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5152 7.20169L10.8084 13.2188H9.72675L12.5758 6.885C12.9042 6.93825 13.2216 7.04525 13.5152 7.20169ZM8.77894 3.66694L4.61475 12.9251C3.55275 12.4211 2.8125 11.3169 2.8125 10.0311C2.8125 8.27044 4.19737 6.84394 5.90625 6.84394C5.90625 5.15925 7.17413 3.78394 8.77894 3.66694ZM12.0943 6.84394L9.22613 13.2188H8.05444L11.6556 5.21438C11.9329 5.69138 12.0943 6.24712 12.0943 6.84394ZM13.1597 13.0213L14.9968 8.93981C15.1183 9.28181 15.1875 9.64856 15.1875 10.0328C15.1875 11.4041 14.3438 12.5724 13.1597 13.0213ZM13.9708 7.50094C14.2273 7.70344 14.4546 7.94419 14.6379 8.22038L12.3958 13.203C12.2957 13.2136 12.195 13.2189 12.0943 13.2188H11.3991L13.9708 7.50094ZM9.01125 3.65625C9.45 3.65794 9.86569 3.75412 10.2431 3.92681L6.06375 13.2188H5.90625C5.51813 13.2188 5.14688 13.1422 4.80544 13.0067L9.01125 3.65625ZM11.4114 4.84763L7.6455 13.2188H6.38212L10.5036 4.05844C10.8534 4.25981 11.1617 4.52869 11.4114 4.84763Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSky);
export default __webpack_public_path__ + "static/media/sky.d79fa9c4dd0a1beebce525d793f65fff.svg";
export { ForwardRef as ReactComponent };